var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoodics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 12048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M3.91211 8.66211C3.91211 5.3484 6.5984 2.66211 9.91211 2.66211H21.4214V7.26758H9.28223C8.72994 7.26758 8.28223 7.71529 8.28223 8.26758V10.5781C8.28223 11.1304 8.72994 11.5781 9.28223 11.5781H15.7204V16.1836H9.91211C6.5984 16.1836 3.91211 13.4973 3.91211 10.1836V8.66211Z",
    fill: "#5830C5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5",
    x: 4.00977,
    y: 17.5029,
    width: 4.48193,
    height: 4.26562,
    rx: 1.5,
    fill: "#5830C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodics);
export default __webpack_public_path__ + "static/media/foodics.412aea3479cb79cb7aaf0a279ca31fb6.svg";
export { ForwardRef as ReactComponent };